import React from "react";
import {EstateCard, EstateCardProps} from "../../EstateCard/EstateCard";
import {Handle, Position} from "@xyflow/react";

export type FirstLevelNodeProps = {
    estateCardProps: EstateCardProps,
    selectCardId?: string,
    selectedCardRef?: React.RefObject<HTMLDivElement>
};

const FirstLevelNode = ({data}: { data: FirstLevelNodeProps }) => {
    return (
        <div>
            <Handle type={"source"} position={Position.Right}/>
            <EstateCard viewMode={data.estateCardProps.viewMode}
                        estateItem={data.estateCardProps.estateItem}
                        selectedCardRef={data.selectedCardRef}
                        isCardSelected={data.selectCardId === data.estateCardProps.estateItem.id}
            />
            <Handle type={"target"} position={Position.Left}/>
        </div>
    );
}

export default FirstLevelNode;